import React, { useState, useEffect, Fragment } from 'react';
import TaskTree from './TaskTree';
import TaskTreeClaroMora from './TaskTreeClaroMora';
import TaskTreeClaroDicom from './TaskTreeClaroDicom';
import TaskTreeForum from './TaskTreeForum';
import TaskTreeTanner from './TaskTreeTanner';
import TaskTreeVtr from './TaskTreeVtr';

const ClientTaskTree = (props) => {
    useEffect(() => {
        //onload execute ....
    }, []);

    let companyId=props.campaign.company_info._id;

    return (
        <Fragment>
            {companyId === 107 ? ( //CLAROMORA
                <TaskTreeClaroMora key={props.clientId} campaign={props.campaign} client={props.client} callbackAfterSaveTask={props.callbackAfterSaveTask} setUserStatus={props.setUserStatus} lastRecordingData={props.lastRecordingData} setLastRecordingData={props.setLastRecordingData} debt={props.debt}/>
            ) : companyId === 108 ? ( //CLAROMORA
                <TaskTreeClaroMora key={props.clientId} campaign={props.campaign} client={props.client} callbackAfterSaveTask={props.callbackAfterSaveTask} setUserStatus={props.setUserStatus} lastRecordingData={props.lastRecordingData} setLastRecordingData={props.setLastRecordingData} debt={props.debt}/>
            ) : companyId === 109 ? ( //CLAROMORA
                <TaskTreeClaroMora key={props.clientId} campaign={props.campaign} client={props.client} callbackAfterSaveTask={props.callbackAfterSaveTask} setUserStatus={props.setUserStatus} lastRecordingData={props.lastRecordingData} setLastRecordingData={props.setLastRecordingData} debt={props.debt}/>
            ) : companyId === 116 || companyId === 117 ? ( //FORUM
                <TaskTreeForum key={props.clientId} campaign={props.campaign} client={props.client} callbackAfterSaveTask={props.callbackAfterSaveTask} setUserStatus={props.setUserStatus} lastRecordingData={props.lastRecordingData} setLastRecordingData={props.setLastRecordingData} debt={props.debt}/>
            ) : companyId === 119 ? ( //TANNER
                <TaskTreeTanner key={props.clientId} campaign={props.campaign} client={props.client} callbackAfterSaveTask={props.callbackAfterSaveTask} setUserStatus={props.setUserStatus} lastRecordingData={props.lastRecordingData} setLastRecordingData={props.setLastRecordingData} debt={props.debt}/>
            ) : companyId === 125 ? ( //CLARO DICOM
               <TaskTreeClaroDicom key={props.clientId} campaign={props.campaign} client={props.client} callbackAfterSaveTask={props.callbackAfterSaveTask} setUserStatus={props.setUserStatus} lastRecordingData={props.lastRecordingData} setLastRecordingData={props.setLastRecordingData} debt={props.debt}/>
            ) : companyId === 126 ? ( //VTR
               <TaskTreeVtr key={props.clientId} campaign={props.campaign} client={props.client} callbackAfterSaveTask={props.callbackAfterSaveTask} setUserStatus={props.setUserStatus} lastRecordingData={props.lastRecordingData} setLastRecordingData={props.setLastRecordingData} debt={props.debt}/>
            ) : ( //GENERIC
                <TaskTree key={props.clientId} campaign={props.campaign} client={props.client} callbackAfterSaveTask={props.callbackAfterSaveTask} setUserStatus={props.setUserStatus} lastRecordingData={props.lastRecordingData} setLastRecordingData={props.setLastRecordingData} debt={props.debt}/>
            )}

        </Fragment>
    );

}

export default ClientTaskTree;
